import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private _baseUrl: string = `${environment.apiUrl}/projects`;

  constructor(private _http: HttpClient) { }

  getConfig(): Observable<any> {
    return this._http.get(`${this._baseUrl}/projects/enums/`);
  }

  getCurrencies(): Observable<any> {
    return this._http.get(`${this._baseUrl}/currencies/`);
  }

  getCountries(): Observable<any> {
    return this._http.get(`${this._baseUrl}/countries/`);
  }

  getCountryRegions(countryId?: number): Observable<any> {
    const params = countryId ? { country: countryId } : undefined;
    return this._http.get(`${this._baseUrl}/regions/`, { params });
  }

  getIndustries(): Observable<any> {
    return this._http.get(`${this._baseUrl}/industries/`);
  }

  getSegments(industry: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/segments/`, {
      params: { industry },
    });
  }
}
